<template>
    <div class="manage--content">
        <!-- Chinese -->
        <div v-if="typeLanguage == 1">
            <!-- Login -->
            <loginManualZh v-if="id == 0"></loginManualZh>

            <!-- Forgot Pass -->
            <forgotPassManualZh v-else-if="id == 1"></forgotPassManualZh>

            <!-- PWA -->
            <pwaManualZh v-else-if="id == 2"></pwaManualZh>
        </div>
        <!-- English -->
        <div v-else-if="typeLanguage == 2">
            <!-- Login -->
            <loginManualEn v-if="id == 0"></loginManualEn>

            <!-- Forgot Pass -->
            <forgotPassManualEn v-else-if="id == 1"></forgotPassManualEn>

            <!-- PWA -->
            <pwaManualEn v-else-if="id == 2"></pwaManualEn>
        </div>
        <!-- Japanese -->
        <div v-else-if="typeLanguage == 3">
            <!-- Login -->
            <loginManualJa v-if="id == 0"></loginManualJa>

            <!-- Forgot Pass -->
            <forgotPassManualJa v-else-if="id == 1"></forgotPassManualJa>

            <!-- PWA -->
            <pwaManualJa v-else-if="id == 2"></pwaManualJa>
        </div>
        <!-- Vietnamese -->
        <div v-else>
            <!-- Login -->
            <loginManualVi v-if="id == 0"></loginManualVi>

            <!-- Forgot Pass -->
            <forgotPassManualVi v-else-if="id == 1"></forgotPassManualVi>

            <!-- PWA -->
            <pwaManualVi v-else-if="id == 2"></pwaManualVi>

            <!-- My Course -->
            <myCourseManualVi v-else-if="id == 3"></myCourseManualVi>
        </div>
    </div>
</template>

<script>
    import loginManualVi from "@/components/manual/content/vi/login_manual";
    import forgotPassManualVi from "@/components/manual/content/vi/forgotPass_manual";
    import pwaManualVi from "@/components/manual/content/vi/pwa_manual";
    import myCourseManualVi from "@/components/manual/content/vi/myCourse_manual";

    import loginManualJa from "@/components/manual/content/ja/login_manual";
    import forgotPassManualJa from "@/components/manual/content/ja/forgotPass_manual";
    import pwaManualJa from "@/components/manual/content/ja/pwa_manual";

    import loginManualEn from "@/components/manual/content/en/login_manual";
    import forgotPassManualEn from "@/components/manual/content/en/forgotPass_manual";
    import pwaManualEn from "@/components/manual/content/en/pwa_manual";

    import loginManualZh from "@/components/manual/content/zh/login_manual";
    import forgotPassManualZh from "@/components/manual/content/zh/forgotPass_manual";
    import pwaManualZh from "@/components/manual/content/zh/pwa_manual";
    
    export default {
        data() {
            return {
                id: 0,
                typeLanguage: 3,
            };
        },
        components: {
            loginManualVi,
            forgotPassManualVi,
            pwaManualVi,
            myCourseManualVi,

            loginManualJa,
            forgotPassManualJa,
            pwaManualJa,

            loginManualEn,
            forgotPassManualEn,
            pwaManualEn,

            loginManualZh,
            forgotPassManualZh,
            pwaManualZh,
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {
            this.typeLanguage = this.$lang();
        },
        watch: {
            data(value) {
                this.id = value.data.id;
            },
        },
        methods: {},
    };
</script>
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/faq/content_faq.vue